/**
 * 应用请求大小
 */
export const blockSizeE = {
    0: '4 KB',
    1: '8 KB',
    2: '16 KB',
    3: '32 KB',
    4: '64 KB',
    5: '>64 KB',
};

export const grainSizeE = {
    8: '4 KB',
    16: '8 KB',
    32: '16 KB',
    64: '32 KB',
    128: '64 KB',
    256: '> 64 KB',
};
